import { createClient, SupabaseClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL ?? "";
const key = process.env.REACT_APP_SUPABASE_ANON_KEY ?? "";

export const supabase: SupabaseClient | null =
  url && key
    ? createClient(url, key, {
        auth: {
          flowType: "pkce",
          persistSession: true,
          storage: localStorage,
          autoRefreshToken: true,
          detectSessionInUrl: true,
        },
      })
    : null;
